import { getAllCountries } from "@/app/api/country";
import { CountryDTO } from "@/app/api/country/types";
import { ErrorResponse } from "@/app/types/error";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

interface CountryState {
  data: CountryDTO[];
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
}

const initialState: CountryState = {
  data: [] as CountryDTO[],
  status: "idle",
  error: null,
};

export const getCountries = createAsyncThunk(
  "countries/all",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getAllCountries();

      if (
        response &&
        typeof response === "object" &&
        "status" in response &&
        response.status === "fail"
      ) {
        return rejectWithValue((response as ErrorResponse).message);
      }

      return response as { data: CountryDTO[] };
    } catch (error) {
      if (error instanceof Error && error.message) {
        return rejectWithValue(error.message);
      }
      return rejectWithValue("An unknown error occurred");
    }
  }
);

const countrySlice = createSlice({
  name: "country",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCountries.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getCountries.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.error = null;
        state.data = action.payload.data;
      })
      .addCase(getCountries.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || null;
      });
  },
});

export const countryReducer = countrySlice.reducer;
